
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1701"}},[_c('path',{attrs:{"data-name":"Rectangle 2406","fill":"none","d":"M0 0h25v20H0z"}}),_c('path',{attrs:{"data-name":"Path 1052","d":"M20.504 11.12V1a1 1 0 00-1-1h-5a1 1 0 000 2h4v3.861l-12 4.473v-7h1.479a1 1 0 000-2h-5a1 1 0 000 2h1.521v7.784a4.509 4.509 0 103.629.742l10.371-3.866v3.126a4.5 4.5 0 102 0zm-15 6.88a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5zm14 0a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z","fill":"#3c3c3c"}})])])
          )
        }
      }
    